module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ThematicClassView.js"));
	}, "ThematicClassView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ThematicClassView!./src/pages/Learn/Thematic/Class/ThematicClassView.js
// module id = 1232
// module chunks = 438